import { render, staticRenderFns } from "./usuario_temp-detalhe.vue?vue&type=template&id=06b3b1d2&"
import script from "./usuario_temp-detalhe.vue?vue&type=script&lang=js&"
export * from "./usuario_temp-detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports